import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import HolidaysCalender from "../../components/holidayscalender.js";
import WholesaleDaysData from "../../components/wholesaledaysdata.js";
import "../../assets/css/inventorymanagement.css";

const CalenderMasterParent = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");

  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  // ✅ default to Wholesale Days tab
  const [activeTab, setActiveTab] = useState("dp");

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
  };

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12 p-0">
            <h1
              className="col-sm-12"
              style={{ color: "#B9366D", fontSize: 18, fontWeight: "bold", fontFamily: "sans-serif" }}
            >
              Calendar Master Data
            </h1>
          </div>

          {/* Tabs */}
          <div className="col-sm-12 p-0 mt-3">
            <ul className="nav nav-tabs" id="calenderMasterTabs" role="tablist" style={{ borderBottom: "1px solid #dee2e6" }}>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "dp" ? "active" : ""}`}
                  id="dp-tab"
                  onClick={() => setActiveTab("dp")}
                  type="button"
                  role="tab"
                  aria-controls="dp"
                  aria-selected={activeTab === "dp"}
                  style={{
                    fontSize: 14,
                    fontWeight: activeTab === "dp" ? 600 : 500,
                    color: activeTab === "dp" ? "#93385D" : "#555",
                    backgroundColor: activeTab === "dp" ? "#fff" : "#f8f9fa",
                    borderBottom: activeTab === "dp" ? "2px solid #93385D" : "none",
                  }}
                >
                  Wholesale Days
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "master" ? "active" : ""}`}
                  id="master-tab"
                  onClick={() => setActiveTab("master")}
                  type="button"
                  role="tab"
                  aria-controls="master"
                  aria-selected={activeTab === "master"}
                  style={{
                    fontSize: 14,
                    fontWeight: activeTab === "master" ? 600 : 500,
                    color: activeTab === "master" ? "#93385D" : "#555",
                    backgroundColor: activeTab === "master" ? "#fff" : "#f8f9fa",
                    borderBottom: activeTab === "master" ? "2px solid #93385D" : "none",
                  }}
                >
                  Holidays
                </button>
              </li>
            </ul>
          </div>

          {/* Tab panes */}
          <div className="tab-content col-sm-12 p-0" id="calenderMasterTabsContent">
            <div
              className={`tab-pane fade ${activeTab === "master" ? "show active" : ""}`}
              id="master"
              role="tabpanel"
              aria-labelledby="master-tab"
            >
              <div className="mt-2">
                <HolidaysCalender />
              </div>
            </div>

            <div
              className={`tab-pane fade ${activeTab === "dp" ? "show active" : ""}`}
              id="dp"
              role="tabpanel"
              aria-labelledby="dp-tab"
            >
              <div className="mt-2">
                <WholesaleDaysData />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* loaders / overlays */}
      <div className={`loader ${loadshow}`} style={{ zIndex: 1002 }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

export default CalenderMasterParent;
